var isNull = function isNull(value) {
  return value === null;
};

module.exports = isNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-null.js
// module id = 317
// module chunks = 0 1 2